import { SET_ORGANIZATION_TYPES } from '../constants/dictionaries';

const initialValues = {
  organizationTypes: [],
};

export default function (state = initialValues, action) {
  switch (action.type) {
    case SET_ORGANIZATION_TYPES:
      return { ...state, organizationTypes: action.payload };
    default:
      return state;
  }
}
